















































import { Component } from "vue-property-decorator";
import { FeriadosService, Feriado } from "@/services/feriados.service";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import { dateTime } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import ComboAno from "./ComboAno.vue";
import Manter from "./Manter.vue";

@Component({
  components: { DataTable, Tooltip, DatePicker, Confirm, ComboAno, Manter },
  filters: { dateTime },
})
export default class Feriados extends mixins(GlobalMixin) {
  filtro = {
    ano: null,
  };
  promise: Promise<Feriado[]> | null = null;

  headers = [
    { value: "descricao", text: "Feriado" },
    { value: "dia", text: "Dia" },
    { value: "mes", text: "Mês" },
    { value: "ano", text: "Ano" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.fetchFeriados();
  }

  fetchFeriados() {
    this.promise = FeriadosService.listarFeriados(this.filtro.ano);
  }

  async novoItem() {
    const modal = this.$refs.manter as Manter;
    await modal.novoFeriado();
    this.atualizaSelectInput();
    this.fetchFeriados();
  }

  async editarItem(feriado: Feriado) {
    const modal = this.$refs.manter as Manter;
    await modal.editarFeriado(feriado.idFeriado);
    this.atualizaSelectInput();
    this.fetchFeriados();
  }

  async excluirItem(item: Feriado) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir feriado: ${item.descricao}`;
    const text = `Deseja realmente excluir o feriado ${item.descricao} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await FeriadosService.excluirFeriado(item.idFeriado).finally(
        this.stopLoader
      );
      this.atualizaSelectInput();
      this.fetchFeriados();
    }
  }

  async atualizaSelectInput() {
    const ano = this.$refs.comboano as ComboAno;
    await ano.fetchFeriados();
  }

  itemRowBackground(item: any) {
    return item.ano == null ? "style-feriado" : "";
  }

  submitForm() {
    this.fetchFeriados();
  }
}
